import { siteApiSlice } from "../../app/siteApiSlice";

export interface DemoUserViewModel {
	id: number;
	role: string;
	username: string;
}

export interface DemoViewModel {
	schoolName: string;
	users: DemoUserViewModel[];
}

export const demoApiSlice = siteApiSlice
	.enhanceEndpoints({
		addTagTypes: ["Demo"],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			// Returns the admin's current demo/sandbox school and its users, or null
			// when no demo school exists yet. (DemoController.Index responds with JSON
			// for SPA requests.)
			getDemo: build.query<DemoViewModel | null, void>({
				query: () => ({
					url: `/Demo`,
				}),
				providesTags: ["Demo"],
			}),
			// Regenerates (or first-time creates) the demo school for the current admin.
			resetDemo: build.mutation<boolean, void>({
				query: () => ({
					url: `/Demo/Reset`,
					method: "POST",
				}),
				invalidatesTags: ["Demo"],
			}),
		}),
	});

export const { useGetDemoQuery, useResetDemoMutation } = demoApiSlice;
